// =============================================================================
// Continental Porsche Portal - Design System Colors
// Based on RefactoringUI principles with Continental Orange (#FFA500) as primary
// =============================================================================

// -----------------------------------------------------------------------------
// PRIMARY - Continental Orange
// Brand color with 9 shades for various use cases
// -----------------------------------------------------------------------------
export const primary = {
  50: '#FFF8E6', // Tinted backgrounds
  100: '#FFEFC2', // Light hover states
  200: '#FFE08A', // Subtle accents
  300: '#FFD152', // Borders
  400: '#FFC21A', // Light interactive
  500: '#FFA500', // Brand primary (Continental Orange)
  600: '#E69500', // Hover state
  700: '#CC8400', // Active/pressed
  800: '#996300', // Dark accent
  900: '#664200', // Text on light orange
};

// -----------------------------------------------------------------------------
// NEUTRAL - Cool Gray
// Corporate/professional feel with slight blue undertone
// -----------------------------------------------------------------------------
export const neutral = {
  50: '#F9FAFB', // Page background
  100: '#F3F4F6', // Card backgrounds
  200: '#E5E7EB', // Borders, dividers
  300: '#D1D5DB', // Disabled borders, scrollbar
  400: '#9CA3AF', // Placeholder text, scrollbar hover
  500: '#6B7280', // Secondary text
  600: '#4B5563', // Body text
  700: '#374151', // Headings
  800: '#1F2937', // Primary text
  900: '#111827', // High emphasis
};

// -----------------------------------------------------------------------------
// SEMANTIC COLORS
// For status indicators, alerts, and feedback
// -----------------------------------------------------------------------------
export const success = {
  light: '#D1FAE5',
  base: '#10B981',
  dark: '#065F46',
};

export const error = {
  light: '#FEE2E2',
  base: '#EF4444',
  dark: '#991B1B',
};

export const info = {
  light: '#DBEAFE',
  base: '#3B82F6',
  dark: '#1E40AF',
};

export const warning = {
  light: '#FEF3C7',
  base: '#F59E0B',
  dark: '#92400E',
};

// -----------------------------------------------------------------------------
// SPECIAL - Domain-specific colors
// -----------------------------------------------------------------------------
export const season = {
  winter: '#93C5FD',
  summer: '#FDB813',
};

// -----------------------------------------------------------------------------
// LEGACY ALIASES (deprecated - use new tokens above)
// Maintained for backward compatibility during migration
// -----------------------------------------------------------------------------
export const orange = primary[500];
export const contiOrange = primary[500];
export const grey = neutral[100];
export const darkGrey = neutral[600];
export const darkishGrey = neutral[400];
export const black = neutral[900];
export const white = '#FFFFFF';
export const red = error.base;
export const blue = info.base;
export const green = success.base;
export const lightGreen = '#10B981';
export const transparent = 'transparent';
export const winter = season.winter;
export const summer = season.summer;
